import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { validationmethod } from "src/app/shared/models/validationmethod";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReleaseLibraryComponent } from "../../release-library/release-library.component";
import { constants } from "src/app/shared/common/contants";
import { TrnxCommonService } from "src/app/shared/services/trnx-common.service";
import { RequirementsLibraryComponent } from "../requirements-library.component";

@Component({
  selector: "app-requirements-library-pop-up",
  templateUrl: "./requirements-library-pop-up.component.html",
  styleUrl: "./requirements-library-pop-up.component.scss",
  standalone:false
})
export class RequirementsLibraryPopUpComponent implements OnInit {
  components: { buttonRenderer: any };
  backgroundColorButton: any;
  backgroundColorScreen: any;
  buttonName = "Save";
  FormValid!: FormGroup;
  systems: any[] = [];
Probability:any;
Detectability:any;
Severity:any;
Risk_Rating:any
Requirement_Classification:any;
  //keys are lookuptype , assignTo :-  are property to which lookup need to be added
  lookups = [
    { key: "Probability", assignTo: "Probability" },
    { key: "Detectability", assignTo: "Detectability" },
    { key: "Severity", assignTo: "Severity" },
    { key: "Risk Rating", assignTo: "Risk_Rating" },
    { key: "Release Classification Rating", assignTo: "Requirement_Classification" },
    // { key: "SignalSourcesV2", assignTo: "SignalSources" },
  ];
  workspaceId: any;
  releases: any;
  modules: any;
  isAutoCalculated = false;

  constructor(
    private fb: FormBuilder,
    public dialogref: MatDialogRef<RequirementsLibraryComponent>,
    private validation: validationmethod,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private constants: constants,
    private trnxService: TrnxCommonService,
  ) {
    this.components = {
      buttonRenderer: Actionbutton,
    };
  }

  ngOnInit(): void {
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.workspaceId = Number(this.localStorage.getSettings("WorkspaceId"));
    console.log("WorkspaceID : ", this.workspaceId);

    this.buildForm();

    this.loadSystems();
    // this.getReleaseLibrary();
    this.getAllLookupValue();

    // this.loadModules();
    console.log("recevied data ",this.data);
    if (this.data) {
     this.updateAndPatchValue(); 
  }

       this.FormValid.get('riskRating')?.valueChanges.subscribe(value => {

    if (this.isAutoCalculated) {
      // First change came from calculate button
      this.isAutoCalculated = false;
      return;
    }

    const rationaleControl = this.FormValid.get('riskRatingChangeRationale');

    rationaleControl?.setValidators([
      Validators.required,
      Validators.maxLength(1000)
    ]);

    rationaleControl?.updateValueAndValidity();
  });

  }

  buildForm(){
    this.FormValid = this.fb.group({
  systemId: ["", Validators.required],
  releaseId: ["", Validators.required],
  moduleId: ["", Validators.required],

  requirementNumber: ["", Validators.required],
  title: ["", Validators.required],
  description: ["", Validators.maxLength(5000)],

  requirementClassification: [[], Validators.required],

  severity: ["", Validators.required],
  probability: ["", Validators.required],
  detectability: ["", Validators.required],

  riskRating: ["", Validators.required],
  riskRatingChangeRationale: [""]
});
  }

  loadSystems() {
    this.spinner.start();

    this.commonService
      .getAllComputerizedSystemLibrary(this.workspaceId)
      .subscribe({
        next: (response: any) => {
          if (response.error == true) {
            this.snackBar.open(response.statusMessage, "Ok", {
              duration: 3000,
            });
            this.spinner.stop();
            console.error("Error retriving ", response.statusMessage);
            return;
          }

          this.systems = response;
          this.spinner.stop();

          if (this.systems.length == 0) {
            this.snackBar.open(
              "No system available ..please create computerized system before proceeding.",
              "Ok",
              { duration: 3000 },
            );
            this.dialogref.close();
            return;
          }
        },
        error: () => {
          this.systems = [];
          this.spinner.stop();
        },
      });
  }

  // release library are now loaded through selected system 

  // getReleaseLibrary() {
  //   this.spinner.start();

  //   this.commonService.getAllReleaseLibrary(this.workspaceId).subscribe({
  //     next: (response: any) => {
  //       if (response.error == true) {
  //         this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
  //         this.spinner.stop();
  //         return;
  //       }
  //       this.releases = response;
  //       this.spinner.stop();
  //     },
  //     error: (err: any) => {
  //       this.spinner.stop();
  //       this.snackBar.open(err.statusMessage, "Ok", { duration: 3000 });
  //     },
  //   });
  // }

  //modules are now loaded from selected system 

  // async loadModules() {

  //   let tableName = "modulemstr"
  //   let dropDownValuesDisplay = "modulename"

  //   this.modules = await this.trnxService.retrieveTrnxDropdownService(
  //     tableName,
  //     0,
  //     dropDownValuesDisplay,
  //   );
  //   this.modules =  this.modules.filter((item) => item.status !== "No");
  //   console.log(this.modules);
  // }

  getAllLookupValue(){
    this.spinner.start();
     // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;
          this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
          this.spinner.stop();
        },
      });
    });
    this.spinner.stop();
  }

updateData(): void {

  if (this.FormValid.invalid) {
    this.FormValid.markAllAsTouched();
    this.snackBar.open("All mandatory fields to be filled", "Ok", { duration: 3000 });
    return;
  }

  const formValue = this.FormValid.getRawValue();

const payload = {
  ...formValue,
    status:"Yes",
    workspaceId:this.workspaceId
};

  console.log("Payload in popup : ",payload);

  this.dialogref.close({
    action: this.buttonName === 'Save' ? 'save' : 'update',
    data: payload
  });
}

close(): void {
  this.dialogref.close();
}


calculateRiskRating(): void {

  const payload = {
    severityId: this.FormValid.value.severity,
    probabilityId: this.FormValid.value.probability,
    detectabilityId: this.FormValid.value.detectability
  };

  if (
    !payload.severityId ||
    !payload.probabilityId ||
    !payload.detectabilityId
  ) {
    this.snackBar.open(
      "Please select Severity, Probability and Detectability.",
      "Ok",
      { duration: 3000 }
    );
    return;
  }

  this.spinner.start();

  this.commonService.calculateRiskRating(payload).subscribe({
    next: (response: any) => {

      this.FormValid.patchValue({
       riskRating: Number(response.data)
      });

      this.spinner.stop();
    },
    error: () => {
      this.spinner.stop();
    }
  });

  // after auto calculate and after patching mark this autoCalculate true ...if true then justification is not mandatory 
   this.isAutoCalculated = true;

 const rationaleControl = this.FormValid.get('riskRatingChangeRationale');

  rationaleControl?.clearValidators();
  rationaleControl?.setValue('');
  rationaleControl?.updateValueAndValidity(); 

}

updateAndPatchValue(){
   this.buttonName = "Update";

  this.FormValid.patchValue({
    systemId: this.data.systemId,
    // releaseId: this.data.releaseId,
    // moduleId: this.data.moduleId,
    requirementNumber: this.data.requirementNumber,
    title: this.data.title,
    description: this.data.description,
    requirementClassification: this.data.requirementClassification,
    severity: this.data.severity,
    probability: this.data.probability,
    detectability: this.data.detectability,

    riskRating: this.data.riskRating,
    riskRatingChangeRationale: this.data.riskRatingChangeRationale
  });

  if (this.data.riskRatingChangeRationale) {
    this.FormValid.get('riskRatingChangeRationale')?.setValidators([
        Validators.required,
        Validators.maxLength(1000)
    ]);

    this.FormValid.get('riskRatingChangeRationale')?.updateValueAndValidity();
}

  // Load dropdowns and patch release/module after API returns
  this.loadReleaseAndModules(this.data.systemId, true);
}


onSystemChange(systemId: number): void {

  this.releases = [];
  this.modules = [];

  this.FormValid.patchValue({
    releaseId: null,
    moduleId: null
  });

  if (!systemId) {
    return;
  }

  this.loadReleaseAndModules(systemId);
}


loadReleaseAndModules(systemId: number, isEdit = false): void {

  this.spinner.start();

  this.commonService
    .getReleaseAndModuleBySystem(this.workspaceId, systemId)
    .subscribe({
      next: (response: any) => {

        const data = JSON.parse(response.data);

        this.releases = data.releases || [];
        this.modules = data.module || [];

        if (isEdit) {
          this.FormValid.patchValue({
            releaseId: this.data.releaseId,
            moduleId: this.data.moduleId
          });
        }

        this.spinner.stop();
      },
      error: () => this.spinner.stop()
    });
}

}